import {Environment} from './environment';

const ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION =
  '0x4AAAAAAAD8MWjIS1dmrt2Y';

const ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION_ADD_TO_BASKET =
  '0x4AAAAAAAAjQZs3okJpHXao';

export const cloudflareChallengeSiteKeyByEnvironment: Record<
  Environment,
  string
> = {
  production: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION,
  preview: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION,
  staging: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION,
  development: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION,
};

export const cloudflareChallengeSiteKeyA2BByEnvironment: Record<
  Environment,
  string
> = {
  production: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION_ADD_TO_BASKET,
  preview: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION_ADD_TO_BASKET,
  staging: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION_ADD_TO_BASKET,
  development: ABOUT_YOU_CF_CHALLENGE_API_SITE_KEY_PRODUCTION_ADD_TO_BASKET,
};
